// Every module's screens. Each app registers them at startup (installUi); only the apps import it.
import { registerUiModules, type UiPart } from "@vavr/screens/shared";
import { installModules } from "./shared.ts";
import { calendarUi } from "./calendar/ui.tsx";
import { emergencyUi } from "./emergency/ui.tsx";
import { lostfoundUi } from "./lostfound/ui.tsx";
import { messagesUi } from "./messages/ui.tsx";
import { radioUi } from "./radio/ui.tsx";
import { transportUi } from "./transport/ui.tsx";

export const UI_MODULES: readonly UiPart[] = [emergencyUi, radioUi, transportUi, messagesUi, lostfoundUi, calendarUi];

/** Module access into the core tables and module screens into the slots. */
export function installUi() {
  installModules();
  registerUiModules(UI_MODULES);
}
